import WPhoto_ScotchDoubleHorizontalComponent from '@wix/thunderbolt-elements/src/components/WPhoto/viewer/skinComps/ScotchDouble/ScotchDoubleHorizontal.skin';
import WPhoto_ScotchDoubleHorizontalController from '@wix/thunderbolt-elements/src/components/WPhoto/viewer/WPhoto.controller';


const WPhoto_ScotchDoubleHorizontal = {
  component: WPhoto_ScotchDoubleHorizontalComponent,
  controller: WPhoto_ScotchDoubleHorizontalController
};


export const components = {
  ['WPhoto_ScotchDoubleHorizontal']: WPhoto_ScotchDoubleHorizontal
};

